export const dictionaryMap = {
  zh: {
    Afghanistan: "阿富汗",
    Angola: "安哥拉",
    Albania: "阿尔巴尼亚",
    "United Arab Emirates": "阿拉伯联合酋长国",
    Argentina: "阿根廷",
    Armenia: "亚美尼亚",
    "French Southern and Antarctic Lands": "法属南部领地",
    Australia: "澳大利亚",
    Austria: "奥地利",
    Azerbaijan: "阿塞拜疆",
    Burundi: "布隆迪",
    Belgium: "比利时",
    Benin: "贝宁",
    "Burkina Faso": "布基纳法索",
    Bangladesh: "孟加拉国",
    Bulgaria: "保加利亚",
    "The Bahamas": "巴哈马",
    "Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
    Belarus: "白俄罗斯",
    Belize: "伯利兹",
    Bermuda: "百慕大群岛",
    Bolivia: "玻利维亚",
    Brazil: "巴西",
    Brunei: "文莱",
    Bhutan: "不丹",
    Botswana: "博茨瓦纳",
    "Central African Republic": "中非共和国",
    Canada: "加拿大",
    Switzerland: "瑞士",
    Chile: "智利",
    China: "中国",
    "Ivory Coast": "象牙海岸",
    Cameroon: "喀麦隆",
    "Democratic Republic of the Congo": "刚果民主共和国",
    "Republic of the Congo": "刚果共和国",
    Colombia: "哥伦比亚",
    "Costa Rica": "哥斯达黎加",
    Cuba: "古巴",
    "Northern Cyprus": "北塞浦路斯",
    Cyprus: "塞浦路斯",
    "Czech Republic": "捷克共和国",
    Germany: "德国",
    Djibouti: "吉布提",
    Denmark: "丹麦",
    "Dominican Republic": "多米尼加共和国",
    Algeria: "阿尔及利亚",
    Ecuador: "厄瓜多尔",
    Egypt: "埃及",
    Eritrea: "厄立特里亚",
    Spain: "西班牙",
    Estonia: "爱沙尼亚",
    Ethiopia: "埃塞俄比亚",
    Finland: "芬兰",
    Fiji: "斐济",
    "Falkland Islands": "福克兰群岛",
    France: "法国",
    Gabon: "加蓬",
    "United Kingdom": "英国",
    Georgia: "格鲁吉亚",
    Ghana: "加纳",
    Guinea: "几内亚",
    Gambia: "冈比亚",
    "Guinea Bissau": "几内亚比绍",
    "Equatorial Guinea": "赤道几内亚",
    Greece: "希腊",
    Greenland: "格陵兰",
    Guatemala: "危地马拉",
    "French Guiana": "法属圭亚那",
    Guyana: "圭亚那",
    Honduras: "洪都拉斯",
    Croatia: "克罗地亚",
    Haiti: "海地",
    Hungary: "匈牙利",
    Indonesia: "印度尼西亚",
    India: "印度",
    Ireland: "爱尔兰",
    Iran: "伊朗",
    Iraq: "伊拉克",
    Iceland: "冰岛",
    Israel: "以色列",
    Italy: "意大利",
    Jamaica: "牙买加",
    Jordan: "约旦",
    Japan: "日本",
    Kazakhstan: "哈萨克斯坦",
    Kenya: "肯尼亚",
    Kyrgyzstan: "吉尔吉斯斯坦",
    Cambodia: "柬埔寨",
    "South Korea": "韩国",
    Kosovo: "科索沃",
    Kuwait: "科威特",
    Laos: "老挝",
    Lebanon: "黎巴嫩",
    Liberia: "利比里亚",
    Libya: "利比亚",
    "Sri Lanka": "斯里兰卡",
    Lesotho: "莱索托",
    Lithuania: "立陶宛",
    Luxembourg: "卢森堡",
    Latvia: "拉脱维亚",
    Morocco: "摩洛哥",
    Moldova: "摩尔多瓦",
    Madagascar: "马达加斯加",
    Mexico: "墨西哥",
    Macedonia: "马其顿",
    Mali: "马里",
    Myanmar: "缅甸",
    Montenegro: "黑山共和国",
    Mongolia: "蒙古",
    Mozambique: "莫桑比克",
    Mauritania: "毛利塔尼亚",
    Malawi: "马拉维",
    Malaysia: "马来西亚",
    Namibia: "纳米比亚",
    "New Caledonia": "新喀里多尼亚",
    Niger: "尼日尔",
    Nigeria: "尼日利亚",
    Nicaragua: "尼加拉瓜",
    Netherlands: "荷兰",
    Norway: "挪威",
    Nepal: "尼泊尔",
    "New Zealand": "新西兰",
    Oman: "阿曼",
    Pakistan: "巴基斯坦",
    Panama: "巴拿马",
    Peru: "秘鲁",
    Philippines: "菲律宾",
    "Papua New Guinea": "巴布亚新几内亚",
    Poland: "波兰",
    "Puerto Rico": "波多黎各",
    "North Korea": "朝鲜",
    Portugal: "葡萄牙",
    Paraguay: "巴拉圭",
    Qatar: "卡塔尔",
    Romania: "罗马尼亚",
    Russia: "俄罗斯",
    Rwanda: "卢旺达",
    "Western Sahara": "西撒哈拉",
    "Saudi Arabia": "沙特阿拉伯",
    Sudan: "苏丹",
    "South Sudan": "南苏丹",
    Senegal: "塞内加尔",
    "Solomon Islands": "所罗门群岛",
    "Sierra Leone": "塞拉利昂",
    "El Salvador": "萨尔瓦多",
    Somaliland: "索马里兰",
    Somalia: "索马里",
    "Republic of Serbia": "塞尔维亚共和国",
    Suriname: "苏里南",
    Slovakia: "斯洛伐克",
    Slovenia: "斯洛文尼亚",
    Sweden: "瑞典",
    Swaziland: "斯威士兰",
    Syria: "叙利亚",
    Chad: "乍得",
    Togo: "多哥",
    Thailand: "泰国",
    Tajikistan: "塔吉克斯坦",
    Turkmenistan: "土库曼斯坦",
    "East Timor": "东帝汶",
    "Trinidad and Tobago": "特立尼达和多巴哥",
    Tunisia: "突尼斯",
    Turkey: "土耳其",
    "United Republic of Tanzania": "坦桑尼亚联合共和国",
    Uganda: "乌干达",
    Ukraine: "乌克兰",
    Uruguay: "乌拉圭",
    "United States of America": "美国",
    Uzbekistan: "乌兹别克斯坦",
    Venezuela: "委内瑞拉",
    Vietnam: "越南",
    Vanuatu: "瓦努阿图",
    "West Bank": "约旦河西岸",
    Yemen: "也门",
    "South Africa": "南非",
    Zambia: "赞比亚",
    Zimbabwe: "津巴布韦",
  },
  en: {
    北京市: "Beijing",
    天津市: "Tianjin",
    河北省: "Hebei province",
    山西省: "Shanxi province",
    内蒙古自治区: "the Nei Monggol Autonomous Region",
    辽宁省: "Liaoning province",
    吉林省: "Jilin province",
    黑龙江省: "Heilongjiang Province",
    上海市: "Shanghai",
    江苏省: "Jiangsu province",
    浙江省: "Zhejiang Province",
    安徽省: "Anhui Province",
    福建省: "Fujian Province",
    江西省: "Jiangxi province",
    山东省: "Shandong province",
    河南省: "Henan province",
    湖北省: "Hubei Province",
    湖南省: "Hunan province",
    广东省: "Guangdong province",
    广西壮族自治区: "Guangxi Zhuang Autonomous Region",
    海南省: "Hainan Province",
    重庆市: "Chongqing Municipality",
    四川省: "Sichuan province",
    贵州省: "Guizhou province",
    云南省: "Yunnan Province",
    西藏自治区: "Tibet Autonomous Region",
    陕西省: "Shaanxi Province",
    甘肃省: "Gansu province",
    青海省: "Qinghai Province",
    宁夏回族自治区: "the Ningxia Hui Autonomous Region",
    新疆维吾尔自治区: "the Xinjiang Uygur Autonomous Region",
    台湾省: "Taiwan province",
    香港: "Hong Kong",
    澳门: "Macao",
  },
};

/**
 * 国家编码
 */
export const countryCode = {
  zh: {
    "100": "保加利亚",
    "104": "缅甸",
    "108": "布隆迪",
    "112": "白俄罗斯",
    "116": "柬埔寨",
    "120": "喀麦隆",
    "124": "加拿大",
    "140": "中非共和国",
    "144": "斯里兰卡",
    "148": "乍得",
    "152": "智利",
    "156": "中国",
    "170": "哥伦比亚",
    "178": "刚果共和国",
    "180": "刚果民主共和国",
    "188": "哥斯达黎加",
    "191": "克罗地亚",
    "192": "古巴",
    "196": "塞浦路斯",
    "203": "捷克共和国",
    "204": "贝宁",
    "208": "丹麦",
    "214": "多米尼加共和国",
    "218": "厄瓜多尔",
    "222": "萨尔瓦多",
    "226": "赤道几内亚",
    "231": "埃塞俄比亚",
    "232": "厄立特里亚",
    "233": "爱沙尼亚",
    "238": "福克兰群岛",
    "242": "斐济",
    "246": "芬兰",
    "250": "法国",
    "254": "法属圭亚那",
    "262": "吉布提",
    "266": "加蓬",
    "268": "格鲁吉亚",
    "270": "冈比亚",
    "276": "德国",
    "288": "加纳",
    "300": "希腊",
    "304": "格陵兰",
    "320": "危地马拉",
    "324": "几内亚",
    "328": "圭亚那",
    "332": "海地",
    "340": "洪都拉斯",
    "348": "匈牙利",
    "352": "冰岛",
    "356": "印度",
    "360": "印度尼西亚",
    "368": "伊拉克",
    "372": "爱尔兰",
    "376": "以色列",
    "380": "意大利",
    "384": "象牙海岸",
    "388": "牙买加",
    "392": "日本",
    "398": "哈萨克斯坦",
    "400": "约旦",
    "404": "肯尼亚",
    "408": "朝鲜",
    "410": "韩国",
    "414": "科威特",
    "417": "吉尔吉斯斯坦",
    "422": "黎巴嫩",
    "426": "莱索托",
    "428": "拉脱维亚",
    "430": "利比里亚",
    "434": "利比亚",
    "440": "立陶宛",
    "442": "卢森堡",
    "450": "马达加斯加",
    "454": "马拉维",
    "458": "马来西亚",
    "466": "马里",
    "478": "毛利塔尼亚",
    "484": "墨西哥",
    "496": "蒙古",
    "498": "摩尔多瓦",
    "499": "黑山共和国",
    "504": "摩洛哥",
    "508": "莫桑比克",
    "512": "阿曼",
    "516": "纳米比亚",
    "524": "尼泊尔",
    "528": "荷兰",
    "540": "新喀里多尼亚",
    "548": "瓦努阿图",
    "554": "新西兰",
    "558": "尼加拉瓜",
    "562": "尼日尔",
    "566": "尼日利亚",
    "578": "挪威",
    "586": "巴基斯坦",
    "591": "巴拿马",
    "598": "巴布亚新几内亚",
    "600": "巴拉圭",
    "604": "秘鲁",
    "608": "菲律宾",
    "616": "波兰",
    "620": "葡萄牙",
    "624": "几内亚比绍",
    "626": "东帝汶",
    "630": "波多黎各",
    "634": "卡塔尔",
    "642": "罗马尼亚",
    "643": "俄罗斯",
    "646": "卢旺达",
    "682": "沙特阿拉伯",
    "686": "塞内加尔",
    "688": "塞尔维亚共和国",
    "694": "塞拉利昂",
    "703": "斯洛伐克",
    "704": "越南",
    "705": "斯洛文尼亚",
    "706": "索马里",
    "710": "南非",
    "716": "津巴布韦",
    "724": "西班牙",
    "728": "南苏丹",
    "729": "苏丹",
    "732": "西撒哈拉",
    "740": "苏里南",
    "748": "斯威士兰",
    "752": "瑞典",
    "756": "瑞士",
    "760": "叙利亚",
    "762": "塔吉克斯坦",
    "764": "泰国",
    "768": "多哥",
    "780": "特立尼达和多巴哥",
    "784": "阿拉伯联合酋长国",
    "788": "突尼斯",
    "792": "土耳其",
    "795": "土库曼斯坦",
    "800": "乌干达",
    "804": "乌克兰",
    "807": "马其顿",
    "818": "埃及",
    "826": "英国",
    "834": "坦桑尼亚联合共和国",
    "840": "美国",
    "854": "布基纳法索",
    "858": "乌拉圭",
    "860": "乌兹别克斯坦",
    "862": "委内瑞拉",
    "887": "也门",
    "894": "赞比亚",
    "004": "阿富汗",
    "024": "安哥拉",
    "008": "阿尔巴尼亚",
    "032": "阿根廷",
    "051": "亚美尼亚",
    "036": "澳大利亚",
    "040": "奥地利",
    "031": "阿塞拜疆",
    "056": "比利时",
    "050": "孟加拉国",
    "044": "巴哈马",
    "070": "波斯尼亚和黑塞哥维那",
    "084": "伯利兹",
    "060": "百慕大群岛",
    "068": "玻利维亚",
    "076": "巴西",
    "096": "文莱",
    "064": "不丹",
    "072": "博茨瓦纳",
    "012": "阿尔及利亚",
    "364": "伊朗",
    "418": "老挝",
    "090": "所罗门群岛",
  },
  en: {
    "100": "Bulgaria",
    "104": "Myanmar",
    "108": "Burundi",
    "112": "Belarus",
    "116": "Cambodia",
    "120": "Cameroon",
    "124": "Canada",
    "140": "Central African Republic",
    "144": "Sri Lanka",
    "148": "Chad",
    "152": "Chile",
    "156": "China",
    "170": "Colombia",
    "178": "Republic of the Congo",
    "180": "Democratic Republic of the Congo",
    "188": "Costa Rica",
    "191": "Croatia",
    "192": "Cuba",
    "196": "Cyprus",
    "203": "Czech Republic",
    "204": "Benin",
    "208": "Denmark",
    "214": "Dominican Republic",
    "218": "Ecuador",
    "222": "El Salvador",
    "226": "Equatorial Guinea",
    "231": "Ethiopia",
    "232": "Eritrea",
    "233": "Estonia",
    "238": "Falkland Islands",
    "242": "Fiji",
    "246": "Finland",
    "250": "France",
    "254": "French Guiana",
    "262": "Djibouti",
    "266": "Gabon",
    "268": "Georgia",
    "270": "Gambia",
    "276": "Germany",
    "288": "Ghana",
    "300": "Greece",
    "304": "Greenland",
    "320": "Guatemala",
    "324": "Guinea",
    "328": "Guyana",
    "332": "Haiti",
    "340": "Honduras",
    "348": "Hungary",
    "352": "Iceland",
    "356": "India",
    "360": "Indonesia",
    "368": "Iraq",
    "372": "Ireland",
    "376": "Israel",
    "380": "Italy",
    "384": "Ivory Coast",
    "388": "Jamaica",
    "392": "Japan",
    "398": "Kazakhstan",
    "400": "Jordan",
    "404": "Kenya",
    "408": "North Korea",
    "410": "South Korea",
    "414": "Kuwait",
    "417": "Kyrgyzstan",
    "422": "Lebanon",
    "426": "Lesotho",
    "428": "Latvia",
    "430": "Liberia",
    "434": "Libya",
    "440": "Lithuania",
    "442": "Luxembourg",
    "450": "Madagascar",
    "454": "Malawi",
    "458": "Malaysia",
    "466": "Mali",
    "478": "Mauritania",
    "484": "Mexico",
    "496": "Mongolia",
    "498": "Moldova",
    "499": "Montenegro",
    "504": "Morocco",
    "508": "Mozambique",
    "512": "Oman",
    "516": "Namibia",
    "524": "Nepal",
    "528": "Netherlands",
    "540": "New Caledonia",
    "548": "Vanuatu",
    "554": "New Zealand",
    "558": "Nicaragua",
    "562": "Niger",
    "566": "Nigeria",
    "578": "Norway",
    "586": "Pakistan",
    "591": "Panama",
    "598": "Papua New Guinea",
    "600": "Paraguay",
    "604": "Peru",
    "608": "Philippines",
    "616": "Poland",
    "620": "Portugal",
    "624": "Guinea Bissau",
    "626": "East Timor",
    "630": "Puerto Rico",
    "634": "Qatar",
    "642": "Romania",
    "643": "Russia",
    "646": "Rwanda",
    "682": "Saudi Arabia",
    "686": "Senegal",
    "688": "Republic of Serbia",
    "694": "Sierra Leone",
    "703": "Slovakia",
    "704": "Vietnam",
    "705": "Slovenia",
    "706": "Somalia",
    "710": "South Africa",
    "716": "Zimbabwe",
    "724": "Spain",
    "728": "South Sudan",
    "729": "Sudan",
    "732": "Western Sahara",
    "740": "Suriname",
    "748": "Swaziland",
    "752": "Sweden",
    "756": "Switzerland",
    "760": "Syria",
    "762": "Tajikistan",
    "764": "Thailand",
    "768": "Togo",
    "780": "Trinidad and Tobago",
    "784": "United Arab Emirates",
    "788": "Tunisia",
    "792": "Turkey",
    "795": "Turkmenistan",
    "800": "Uganda",
    "804": "Ukraine",
    "807": "Macedonia",
    "818": "Egypt",
    "826": "United Kingdom",
    "834": "United Republic of Tanzania",
    "840": "United States of America",
    "854": "Burkina Faso",
    "858": "Uruguay",
    "860": "Uzbekistan",
    "862": "Venezuela",
    "887": "Yemen",
    "894": "Zambia",
    "004": "Afghanistan",
    "024": "Angola",
    "008": "Albania",
    "032": "Argentina",
    "051": "Armenia",
    "036": "Australia",
    "040": "Austria",
    "031": "Azerbaijan",
    "056": "Belgium",
    "050": "Bangladesh",
    "044": "The Bahamas",
    "070": "Bosnia and Herzegovina",
    "084": "Belize",
    "060": "Bermuda",
    "068": "Bolivia",
    "076": "Brazil",
    "096": "Brunei",
    "064": "Bhutan",
    "072": "Botswana",
    "012": "Algeria",
    "364": "Iran",
    "418": "Laos",
    "090": "Solomon Islands",
  },
};

export const provinceCode = {
  zh: {
    "11": "北京市",
    "12": "天津市",
    "13": "河北省",
    "14": "山西省",
    "15": "内蒙古自治区",
    "21": "辽宁省",
    "22": "吉林省",
    "23": "黑龙江省",
    "31": "上海市",
    "32": "江苏省",
    "33": "浙江省",
    "34": "安徽省",
    "35": "福建省",
    "36": "江西省",
    "37": "山东省",
    "41": "河南省",
    "42": "湖北省",
    "43": "湖南省",
    "44": "广东省",
    "45": "广西壮族自治区",
    "46": "海南省",
    "50": "重庆市",
    "51": "四川省",
    "52": "贵州省",
    "53": "云南省",
    "54": "西藏自治区",
    "61": "陕西省",
    "62": "甘肃省",
    "63": "青海省",
    "64": "宁夏回族自治区",
    "65": "新疆维吾尔自治区",
    "71": "台湾省",
    "81": "香港",
    "82": "澳门",
    "83": "台湾省",
  },
  en: {
    "11": "Beijing",
    "12": "Tianjin",
    "13": "Hebei province",
    "14": "Shanxi province",
    "15": "the Nei Monggol Autonomous Region",
    "21": "Liaoning province",
    "22": "Jilin province",
    "23": "Heilongjiang Province",
    "31": "Shanghai",
    "32": "Jiangsu province",
    "33": "Zhejiang Province",
    "34": "Anhui Province",
    "35": "Fujian Province",
    "36": "Jiangxi province",
    "37": "Shandong province",
    "41": "Henan province",
    "42": "Hubei Province",
    "43": "Hunan province",
    "44": "Guangdong province",
    "45": "Guangxi Zhuang Autonomous Region",
    "46": "Hainan Province",
    "50": "Chongqing Municipality",
    "51": "Sichuan province",
    "52": "Guizhou province",
    "53": "Yunnan Province",
    "54": "Tibet Autonomous Region",
    "61": "Shaanxi Province",
    "62": "Gansu province",
    "63": "Qinghai Province",
    "64": "the Ningxia Hui Autonomous Region",
    "65": "the Xinjiang Uygur Autonomous Region",
    "71": "Taiwan province",
    "81": "Hong Kong",
    "82": "Macao",
    "83": "Taiwan province",
  },
};
